export const BASE_URL = process.env.VUE_APP_API_HOST || 'http://localhost:5000/';
export const IS_MZ_BRANDING = (process.env.VUE_APP_IS_MZ_BRANDING || '').toLowerCase() === 'true';
export const IS_MAINTENANCE = (process.env.VUE_APP_IS_MAINTENANCE || '').toLowerCase() === 'true';
export const CAPTCHA_KEY = process.env.VUE_APP_CAPTCHA_KEY || '6Lfy2T8pAAAAAEfhkZJbc1IM5IzraIxCOBbZzQJc';
